import { firebaseAuth } from 'lib/firebase/firebase.client';
import { getOptionalStringEnv } from 'utils/safeEnvParsing';

import { initSettingsSync } from './service';
import { subscribeAll } from './subscriptions';

let cleanupFunction: (() => void) | null = null;
let lastSyncTimestamp = 0;

const isDev = getOptionalStringEnv('NEXT_PUBLIC_IS_DEV');
const HOT_RELOAD_THRESHOLD = 5000; // 5 seconds

export function initializeSettingsSyncWithAuth(): () => void {
  if (isDev) {
    const now = Date.now();
    const timeSinceLastSync = now - lastSyncTimestamp;

    if (timeSinceLastSync < HOT_RELOAD_THRESHOLD) {
      console.debug('Skipping settings sync due to hot reload');
      return () => {};
    }

    lastSyncTimestamp = now;
  }

  if (cleanupFunction) {
    cleanupFunction();
    cleanupFunction = null;
  }

  const unsubscribe = firebaseAuth.onAuthStateChanged(async user => {
    if (cleanupFunction) {
      cleanupFunction();
      cleanupFunction = null;
    }

    if (user && !user.isAnonymous) {
      const subscriptionsCleanup = await subscribeAll();
      const settingsSyncCleanup = initSettingsSync();

      cleanupFunction = () => {
        subscriptionsCleanup();
        settingsSyncCleanup();
      };
    }
  });

  return () => {
    unsubscribe();

    if (cleanupFunction) {
      cleanupFunction();
      cleanupFunction = null;
    }
  };
}
